@if (fileContent.hasValue()) {
  <div class="w-full h-full overflow-auto whitespace-pre-wrap">
    {{ fileContent.value() }}
  </div>
}
